import gql from 'graphql-tag';


const MUTATION_REMOVE_MEMBERSHIP_FROM_BUSINESS_PLAN = gql`
	mutation RemoveMembershipFromBusinessPlan($businessPlanID: String!, $membershipID: String!) {
		removeMembershipFromBusinessPlan(businessPlanID: $businessPlanID, membershipID: $membershipID)
	}
`;

export default MUTATION_REMOVE_MEMBERSHIP_FROM_BUSINESS_PLAN;